export default __webpack_public_path__ + "static/media/import.e2117b68.svg";